var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",null,React.createElement("path",{"d":"M11.6,22.1c-1-1-1.5-2.3-1.5-3.7c0-1.4,0.5-2.7,1.5-3.7c2-2,5.3-2,7.3,0l64.6,64.6l64.6-64.6c2-2,5.3-2,7.3,0\n\t\t\tc2,2,2,5.3,0,7.3L87.3,90.3c-2,2-5.3,2-7.3,0L11.6,22.1z M11.6,22.1"}))));
}

ArrowDown.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 167.2 105","style":{"enableBackground":"new 0 0 167.2 105"},"xmlSpace":"preserve"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
